import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: <>
        Nunca había trabajado con resina. Seguí el libro paso a paso y{' '}
        <strong className="text-[#1A3A5C]" data-id="element-244">
          en 7 días terminé mi primera mesa
        </strong>{' '}
        con un brillo que no podía creer. Ya me encargaron dos más.
      </>,
  name: 'Mariana R.',
  location: 'Montevideo',
  initials: 'MR'
}, {
  quote: <>
        Todo está pensado para Uruguay. Conseguí cada material en ferreterías
        locales sin buscar nada afuera.{' '}
        <span className="highlight-yellow" data-id="element-245">El resultado fue increíble.</span>
      </>,
  name: 'Diego M.',
  location: 'Punta del Este',
  initials: 'DM'
}, {
  quote: <>
        Tenía miedo de arruinar la resina y perder la plata. La guía es tan
        clara que{' '}
        <strong className="text-[#1A3A5C]" data-id="element-246">
          me salió perfecto desde la primera vez
        </strong>
        .
      </>,
  name: 'Sofía L.',
  location: 'Canelones',
  initials: 'SL'
}, {
  quote: <>
        La resina se me pegó al molde y gracias al capítulo de errores pude
        recuperar la mesa sin perder nada.{' '}
        <span className="highlight-yellow" data-id="element-247">
          Sin esa guía hubiera tirado todo.
        </span>
      </>,
  name: 'Rodrigo P.',
  location: 'Salto',
  initials: 'RP'
}, {
  quote: <>
        Aprendí a calcular bien el precio de mis mesas. Dejé de regalar el
        trabajo y ahora{' '}
        <strong className="text-[#1A3A5C]" data-id="element-248">cobro lo que corresponde</strong>.
      </>,
  name: 'Laura V.',
  location: 'Rivera',
  initials: 'LV'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function TestimonialsSection() {
  return <section className="py-[56px] md:py-[80px] px-5 bg-[#FFFFFF] relative" data-id="element-249">
      <div className="max-w-7xl mx-auto" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-251">
          <h2 className="text-title-section font-bold text-[#1A3A5C] mb-6 flex items-center justify-center gap-4" data-id="element-252">
            <StarIcon className="w-8 h-8 text-[#DAA520] fill-[#DAA520]" data-id="element-253" />
            LO QUE DICEN NUESTROS CLIENTES
          </h2>
          <div className="w-24 h-1 bg-[#C9A84C]/30 mx-auto mt-6" data-id="element-254"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="columns-1 sm:columns-2 lg:columns-3 gap-[20px]" data-id="element-255">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className="masonry-card card-light p-[22px] md:p-[26px] flex flex-col hover:border-[#C9A84C] hover:shadow-md transition-all duration-300" data-id="element-256">
              <div className="flex gap-1 mb-[12px]" data-id="element-257">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-[18px] h-[18px] text-[#DAA520] fill-[#DAA520]" data-id="element-258" />)}
              </div>
              <blockquote className="text-body-main text-gray-700 italic mb-[18px] flex-grow" data-id="element-259">
                "{testimonial.quote}"
              </blockquote>
              <div className="mt-auto pt-4 border-t border-gray-100 flex items-center gap-3" data-id="element-260">
                <div className="w-10 h-10 rounded-full bg-[#EFF6FF] flex items-center justify-center text-[#1A3A5C] font-bold text-sm shrink-0" data-id="element-261">
                  {testimonial.initials}
                </div>
                <div data-id="element-262">
                  <p className="font-bold text-gray-900 mb-0.5 text-sm" data-id="element-263">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-264">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}